import React from 'react';
import {ForecastQueryRenderer} from '../../ForecastQueryRenderer';
import {hasFeatureFlag} from '../shared/util/FeatureUtil';
import OpportunitiesPage, {OpportunitiesPageQuery} from './OpportunitiesPage';

// Picks which financial fragment the query includes: the single-currency one when the company loads
// project financials in company currency, the multi-currency one otherwise. Exactly one is always true,
// because the Target Value column reads `financialNumbers.baselineRevenue` from whichever is included —
// leaving both false makes the column permanently blank, since nothing else on the page selects that field.
//
// This deliberately differs from the Projects list, which additionally suppresses both fragments when the
// financial-categories flag is on: that list also drops its financial columns in that mode, so it has no
// value left to fetch. The Opportunities list keeps Target Value in every mode and so always needs the data.
//
// Narrowed by IGNITE-640: Target Value is no longer sourced from financialNumbers alone — T&M rows read
// ProjectType.baselineTarget, which rides OpportunitiesList_project and is outside this @include gate.
// So getting this wrong now blanks Fixed Fee rows only, leaving T&M rows rendering: a partially blank
// column, subtler than the fully blank one this invariant was written for. See 003 D12.
export const OpportunitiesPageQueryWrapper = (): JSX.Element => {
	const loadSingleCurrency = hasFeatureFlag('projects_overview_load_single_currency');
	const loadMultiCurrency = !hasFeatureFlag('projects_overview_load_single_currency');
	return (
		<ForecastQueryRenderer
			key="query-render-opportunities"
			query={OpportunitiesPageQuery}
			fetchPolicy="store-and-network"
			variables={{loadSingleCurrency, loadMultiCurrency}}
			render={(relayProps, retry) => <OpportunitiesPage {...relayProps} retry={retry} />}
		/>
	);
};
